import moment from 'moment'

export const formatDateAndMonth = (date) => {
    return moment(date).format('DD/MM');
}

export const formatDate = (date) => {
    return moment(date).format('MMM D, YYYY');
}

export const formatPayloadDate = (date) => {
    return moment(date).format('YYYY-MM-DD');
}

export const formatPayloadDatetime = (date) => {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
}